'use client';

import React from 'react';
import { useComponentTranslations } from '@/app/components/LanguageProvider';
import { useLocale } from '@/app/components/LocaleProvider';
import PageHero from '@/app/components/PageHero';
import PageContainer from '@/app/components/PageContainer';
import PageSection from '@/app/components/PageSection';
import SectionTitle from '@/app/components/SectionTitle';
import GlassCard from '@/app/components/GlassCard';
import PartnerForm from '@/app/components/PartnerForm';

export default function PartnerPage() {
    const { t } = useComponentTranslations("Partners");
    const locale = useLocale();
    const isEn = locale.startsWith('en');

    return (
        <div className="min-h-screen text-white">
            <PageContainer>
                <PageHero
                    id="partners-hero"
                    title={t('partnerPageTitle', isEn ? 'Partners' : 'Партнёры')}
                    description={t('partnerPageSubtitle', isEn ? 'The Dev48 partner program for business.' : 'Партнёрская программа Dev48 для бизнеса.')}
                    badges={
                        isEn
                            ? ["Up to 20% commission", "Payouts in USDT / Fast wire"]
                            : ["До 20% commission", "Payouts in USDT / Fast wire"]
                    }
                    actions={[
                        {
                            href: "#partner-form",
                            label: isEn ? "Submit a request" : "Подать заявку",
                            primary: true,
                            ctaLocation: "pagehero_partners_primary",
                        },
                        {
                            href: "#terms",
                            label: isEn ? "Program terms" : "Условия программы",
                            ctaLocation: "pagehero_partners_secondary",
                        },
                    ]}
                />
            </PageContainer>

            <PageSection id="partner-form">
                <SectionTitle
                    title={isEn ? "Partnership request" : "Заявка на партнёрство"}
                    description={
                        isEn
                            ? "Tell us about your company and the format you have in mind — we will come back with next steps."
                            : "Расскажите о компании и формате сотрудничества — вернёмся со следующими шагами."
                    }
                />
                <GlassCard className="p-6 md:p-8">
                    <PartnerForm />
                </GlassCard>
            </PageSection>
        </div>
    );
}
